var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 49,
    viewBox: "0 0 64 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.945 0C26.8218 0 27.4595 0.321839 27.858 0.965517C28.2566 1.6092 28.3363 2.33333 28.0971 3.13793L22.2386 24.3793V46.2241C22.2386 48.0747 21.3618 49 19.6082 49H2.63037C0.87679 49 0 48.0747 0 46.2241V26.431C0 25.4655 0.318833 24.3391 0.956499 23.0517L15.0649 1.93103C15.9416 0.643678 17.0177 0 18.293 0H25.945ZM61.8137 0C62.6905 0 63.3282 0.321839 63.7267 0.965517C64.0455 1.44828 64.0854 2.17241 63.8463 3.13793L58.1073 24.3793V46.2241C58.1073 47.1092 57.8682 47.7931 57.3899 48.2759C56.9117 48.7586 56.2341 49 55.3574 49H38.3795C36.6259 49 35.7491 48.0747 35.7491 46.2241V26.431C35.7491 25.4655 36.068 24.3391 36.7056 23.0517L50.9335 1.93103C51.7306 0.643678 52.7668 0 54.0422 0H61.8137Z",
    fill: "#B4E2C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quote-icon.74c4a2344f6a0f5c6767d3089d904a2b.svg";
export { ForwardRef as ReactComponent };